import { render, staticRenderFns } from "./MessageCreate.vue?vue&type=template&id=51588530&"
import script from "./MessageCreate.vue?vue&type=script&lang=js&"
export * from "./MessageCreate.vue?vue&type=script&lang=js&"
import style0 from "./MessageCreate.vue?vue&type=style&index=0&id=51588530&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports